// extracted by mini-css-extract-plugin
export default {"wrapper":"ColorSelector_wrapper__2kRpY","circle":"ColorSelector_circle__38b5K"};